export type DataAnalyticsProps = {
    dataAnalyticsEvent: string | null;
    dataAnalyticsProps: string | null;
};

export function toDataAnalyticsHtmlAttributes(
    dataAnalyticsEvent: string | null,
    dataAnalyticsProps: string | null,
): {
    "data-analytics-event"?: string;
    "data-analytics-props"?: string;
} {
    const attributes: {
        "data-analytics-event"?: string;
        "data-analytics-props"?: string;
    } = {};
    if (dataAnalyticsEvent !== null) {
        attributes["data-analytics-event"] = dataAnalyticsEvent;
    }
    if (dataAnalyticsProps !== null) {
        attributes["data-analytics-props"] = dataAnalyticsProps;
    }
    return attributes;
}
